// extracted by mini-css-extract-plugin
module.exports = {"networkStatus":"style_networkStatus__1dOC1","network":"style_network__rqCaD","statusText":"style_status-text__9aQyq"};